import React from "react";
import PropTypes from "prop-types";

import StoryCardDP95MP32 from "../../atoms/story-card-dp-9-5-mp-3-2";
import StoryCardDL43ML54 from "../../atoms/story-card-dl-4-3-ml-5-4";

import styles from "./styles.m.css";

const StoryStackD2 = ({ bigStory, mobileStoryCount, stories, className }) => {
  if (stories.length < 1) {
    return null;
  }
  const stack = [
    bigStory ? (
      <StoryCardDP95MP32 story={stories[0]} key={stories[0].id} hasTruncatedHeadline={true} />
    ) : (
      <StoryCardDL43ML54 story={stories[0]} className={`${styles["line-separater"]}`} key={stories[0].id} />
    )
  ].concat(
    stories.slice(1).map((story, index) => (
      <StoryCardDL43ML54
        story={story}
        className={`
          ${styles[index + 1 >= mobileStoryCount ? "mobile-hide" : ""]}
          ${styles["line-separater"]}
          ${styles[index + 2 === mobileStoryCount ? "skip-line" : ""]}
        `}
        key={story.id}
      />
    ))
  );
  return <div className={`${styles["base"]} ${className}`}>{stack}</div>;
};

StoryStackD2.propTypes = {
  bigStory: PropTypes.bool,
  mobileStoryCount: PropTypes.number,
  stories: PropTypes.arrayOf(StoryCardDP95MP32.propTypes.story),
  className: PropTypes.string
};

export default StoryStackD2;
